import Seo from "@/components/seo/Seo";
import { SITE_INFO, faqs } from "@/mocks/data";
import Hero from "@/pages/home/components/Hero";
import CategoryNav from "@/pages/home/components/CategoryNav";
import FeaturedComics from "@/pages/home/components/FeaturedComics";
import LatestArticles from "@/pages/home/components/LatestArticles";
import Community from "@/pages/home/components/Community";
import FaqSection from "@/pages/home/components/FaqSection";
import Newsletter from "@/pages/home/components/Newsletter";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE_INFO.name,
      slogan: SITE_INFO.slogan,
      url: SITE_INFO.domain,
      email: SITE_INFO.contact,
      telephone: SITE_INFO.phone,
      address: { "@type": "PostalAddress", streetAddress: SITE_INFO.address, addressCountry: "CN" },
      foundingDate: String(SITE_INFO.founded),
      sameAs: [SITE_INFO.domain],
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE_INFO.name,
      url: SITE_INFO.domain,
      description: SITE_INFO.description,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_INFO.domain}/category?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "漫画岛首页 - 漫画同好讨论社区",
      url: SITE_INFO.domain,
      isPartOf: { "@type": "WebSite", name: SITE_INFO.name, url: SITE_INFO.domain },
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];

  return (
    <>
      <Seo
        title="漫画岛 - 漫画同好讨论社区"
        description="漫画岛是一个面向漫画爱好者的同好讨论社区，聚合漫画评论区、粉丝圈子与书评交流。热门漫画安利、深度书评、追更讨论与推荐互助，看完漫画来聊剧情、求推荐，找同好一起追更。"
        keywords="漫画岛,漫画岛同好讨论,漫画评论区,漫画粉丝圈子,漫画书评交流,漫画推荐,热门漫画"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <CategoryNav />
      <FeaturedComics />
      <LatestArticles />
      <Community />
      <FaqSection />
      <Newsletter />
    </>
  );
}